import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useRestartMyDeviceModeEnabled = (iotDevice) => {
    const isGlobalReset = iotDeviceGlobalConfigService.isGlobalReset(iotDevice);
    const isDeviceResetEnabled = iotDeviceFeatureConfigService.isDeviceResetEnabled();
    const isResetEnabled = iotDeviceSettingsService.isSettingAvailable(iotDevice, isGlobalReset, isDeviceResetEnabled);

    return isResetEnabled;
};

export default useRestartMyDeviceModeEnabled;
